import { Extension } from '@tiptap/core'

export const BgGradientColor = Extension.create({
  name: 'bgGradientColor',

  addGlobalAttributes () {
    return [
      {
        types: ['textStyle'],
        attributes: {
          bgGradientColor: {
            default: null,
            parseHTML: element => {
              const bg = element.style?.backgroundImage || ''
              const clip = element.style?.webkitBackgroundClip || element.style?.backgroundClip || ''
              // Only treat as bg gradient if there's NO text clip (text clip = text color gradient)
              if (bg && bg.includes('gradient') && clip !== 'text') {
                return bg
              }
              return null
            },
            renderHTML: attributes => {
              if (!attributes.bgGradientColor) {
                return {}
              }

              return {
                style: `background-image: ${attributes.bgGradientColor};`
              }
            }
          }
        }
      }
    ]
  },

  addCommands () {
    return {
      setBgGradientColor:
        color =>
          ({ chain }) =>
            chain()
              .setMark('textStyle', { bgGradientColor: color })
              .run(),

      unsetBgGradientColor:
        () =>
          ({ chain }) =>
            chain()
              .setMark('textStyle', { bgGradientColor: null })
              .removeEmptyTextStyle?.()
              .run()
    }
  }
})
